import React from 'react';
import { StyledTag, StyledTagText } from './SelectFilterTag.styles';

export interface SelectFilterTagProps<T> {
  value: string;
}

export const SelectFilterTag = <T extends string>({ value }: SelectFilterTagProps<T>) => {
  return (
    <StyledTag marginLeft={1} paddingX={3} paddingY={1}>
      <StyledTagText variant="caption" tagName="p" color="white">
        {value}
      </StyledTagText>
    </StyledTag>
  );
};
